import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { map } from 'rxjs';

function isFlagOn(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined;
}

/**
 * Home Ask Navi search. Navigates to `/ask-navi?q=` so the layout can seed
 * {@link AskNaviChatStateService.sendMessage}. Suggestion chips are not
 * hardcoded here — they are owned by the chat-suggestions API/admin, keyed by
 * agent id, which does not apply on Home.
 */
@Component({
  selector: 'an-ask-navi-go-widget',
  standalone: true,
  imports: [CommonModule, FormsModule, Button, InputText],
  templateUrl: './ask-navi-go-widget.component.html',
  styleUrl: './ask-navi-go-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskNaviGoWidgetComponent {
  private readonly _router = inject(Router);
  private readonly _flags = inject(FeatureFlagsService);

  readonly query = signal('');
  readonly askNaviEnabled = toSignal(
    this._flags
      .getValueChanges$(FeatureFlagKey.ENABLEASKNAVI, false)
      .pipe(map((value) => isFlagOn(value))),
    { initialValue: false },
  );

  go(): void {
    const q = this.query().trim();
    if (!q) {
      void this._router.navigate(['/ask-navi']);
      return;
    }
    void this._router.navigate(['/ask-navi'], { queryParams: { q } });
  }
}
